import Config from 'es6/core/config';
import { location } from 'es6/services/window';
import { crc32 } from 'crc';

export default function assetPath(file) {
  return hostPart(file) + pathPart() + filePart(file);
}

function hostPart(file) {
  const host = Config.getAssetHost();

  if (host && !location.isConnectionSecure()) {
    const randomizedHost = host.replace(/%d/g, function () {
      return crc32(file) % Config.getAssetCdns();
    });

    return `//${cleanSlashes(randomizedHost)}`;
  } else {
    return '';
  }
}

function pathPart() {
  const path = Config.getAssetPath() || '';
  return `/${cleanSlashes(path)}`;
}

function filePart(file) {
  return `/${cleanSlashes(file)}`;
}

function cleanSlashes(path) {
  return (path.replace(/\/+/g, '/')
    .replace(/^\//, '')
    .replace(/\/$/, ''));
}
